import {InputSwitch} from "primereact/inputswitch";
import {FunctionComponentElement,  useState} from "react";
import {NodeInputProps} from "./index";


export const BooleanString = (props: NodeInputProps): FunctionComponentElement<NodeInputProps> =>{

    const [valueByDefault] = useState(() => {
        if(props.defaultValue === "true") return true
        if(props.defaultValue === "false") return false
        return false
    })

    return <InputSwitch checked={props.value === undefined ? valueByDefault : props.value} disabled={props.disabled} onChange={(e) => {
        props.onChange(e.value);
    }}/>
}